module.exports = __webpack_public_path__ + "static/media/248-russia.419ef1e1.svg";